import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-detail-image',
  templateUrl: 'page.html'
})
export class DetailImagePage {

  url_image='https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/300px-No_image_available.svg.png';
  detail:any = {};
  imageWidth="100%";
  rotationAmount = 0;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    this.url_image = this.navParams.get('url_image');
    if(this.navParams.get('detail')!=undefined){
      this.detail = this.navParams.get('detail');
      console.log(this.detail);
    }
  }

  closeModal() {
    let data = { 'foo': 'bar' };
    this.viewCtrl.dismiss(data);
  }

  perbesar(){
    let n = parseInt(this.imageWidth)+10;
    this.imageWidth = n+"%";
  }

  perkecil(){
    let n = parseInt(this.imageWidth)-10;
    this.imageWidth = n+"%";
  }

  rotateImage(){
    var angle = this.rotationAmount +=90;
    if (this.rotationAmount == 360){
      this.rotationAmount = 0;
    }
    document.getElementById('image').style.transform='rotate('+angle+'deg)';
    console.log("rotate image => ",angle,"deg");
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketing/detail_image/page.ts